import {
  FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_START,
  FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_FULFILLED,
  FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_REJECTED,
  FETCH_SHARED_WORKOUT_PREVIEW_START,
  FETCH_SHARED_WORKOUT_PREVIEW_FULFILLED,
  FETCH_SHARED_WORKOUT_PREVIEW_REJECTED,
  SET_ACTIVE_SHARED_WORKOUT_MODAL,
  SET_IS_DOWNLOAD_BUTTON_CLICKED,
  DOWNLOAD_SHARED_WORKOUT_START,
  DOWNLOAD_SHARED_WORKOUT_FULFILLED,
  DOWNLOAD_SHARED_WORKOUT_REJECTED,
} from './actionTypes';

import { axiosAuthed, axiosUnauthed } from '../../../shared/utils/setCommonHeaders';
import { showErrorToast } from '../../../shared/utils/toastManager';
import pollTransferStatus from '../../../shared/utils/transferPolling';

export const fetchProgram = (programSlug) => (
  (dispatch) => {
    dispatch({ type: FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_START });
    axiosUnauthed.get(`/public/shared-workouts/${programSlug}`)
      .then((response) => {
        setTimeout(() => {
          dispatch({
            type: FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_FULFILLED,
            payload: response.data,
          });
        }, 800);
      })
      .catch((err) => {
        setTimeout(() => {
          dispatch({
            type: FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_REJECTED,
            payload: err,
          });
        }, 800);
      });
  }
);

export const fetchWorkout = (programSlug) => (
  (dispatch) => {
    dispatch({ type: FETCH_SHARED_WORKOUT_PREVIEW_START });
    axiosUnauthed.get(`/public/shared-workouts/${programSlug}/workout-preview`)
      .then((response) => {
        setTimeout(() => {
          dispatch({
            type: FETCH_SHARED_WORKOUT_PREVIEW_FULFILLED,
            payload: response.data,
          });
        }, 800);
      })
      .catch((err) => {
        dispatch({
          payload: err,
          type: FETCH_SHARED_WORKOUT_PREVIEW_REJECTED,
        });
      });
  }
);

// Bumped on download start or modal close; a poll chain whose token no longer matches
// stops dispatching, so a stale poll can't flip state and a newer download wins.
let activeDownloadRun = 0;

export const cancelSharedWorkoutDownload = () => () => {
  activeDownloadRun += 1;
};

export const downloadSharedWorkout = ({
  targetAccountCode,
  savedWorkoutId,
  targetExerciseDatabase,
}) => (
  (dispatch) => {
    activeDownloadRun += 1;
    const runId = activeDownloadRun;
    dispatch({ type: DOWNLOAD_SHARED_WORKOUT_START });
    axiosAuthed.post('/saved-workouts/transfer', {
      targetAccountCode,
      savedWorkoutId,
      targetExerciseDatabase,
    })
      .then((response) => pollTransferStatus(
        response.data.transferId,
        () => runId !== activeDownloadRun,
      ))
      .then((status) => {
        if (runId !== activeDownloadRun || status.cancelled) return;
        if (status.success) {
          dispatch({ type: DOWNLOAD_SHARED_WORKOUT_FULFILLED, payload: { pending: false } });
        } else if (status.timedOut) {
          // Still importing server-side; report a graceful "will appear shortly" completion
          // rather than a false failure.
          dispatch({ type: DOWNLOAD_SHARED_WORKOUT_FULFILLED, payload: { pending: true } });
        } else {
          dispatch({ type: DOWNLOAD_SHARED_WORKOUT_REJECTED });
          showErrorToast(status.errorMessage || 'An error occurred while downloading this program.');
        }
      })
      .catch((err) => {
        if (runId !== activeDownloadRun) return;
        dispatch({ type: DOWNLOAD_SHARED_WORKOUT_REJECTED });
        showErrorToast(err?.response?.headers?.message || 'An error occurred while downloading this program.');
      });
  }
);

export const sharedWorkoutModal = (activeModal) => ({
  type: SET_ACTIVE_SHARED_WORKOUT_MODAL,
  payload: {
    activeModal,
  },
});

export const setDownloadButtonClicked = (bool) => ({
  type: SET_IS_DOWNLOAD_BUTTON_CLICKED,
  payload: {
    bool,
  },
});
